module.exports = __webpack_public_path__ + "static/media/carta_80.0f339552.jpg";